import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import classes from './GettingStartedHelp.module.scss'

const GettingStartedHelp = () => {
  const { t } = useTranslation()

  return (
    <footer className={classNames('d-flex align-items-center', classes.band)}>
      <span className={classNames('d-flex align-items-center justify-content-center flex-shrink-0', classes.icon)}>
        <i className='fa fa-comments-o' aria-hidden='true' />
      </span>
      <span className='flex-grow-1'>{t('portal.gettingStarted.help')}</span>
      <button type='button' className={classes.pillButton} onClick={() => window.Intercom?.('show')}>
        {t('portal.gettingStarted.chatWithUs')}
      </button>
    </footer>
  )
}

export default GettingStartedHelp
